module.exports = __webpack_public_path__ + "img/step-5.2b0a3852.jpg";